import React from 'react';
import Icon from './Icon';
import LiveCall from './LiveCall';
import { BRAND } from '../site';
import { LANGUAGES } from '../data/conversations';

export default function Hero() {
  return (
    <section className="hero dark" id="top">
      <div className="hero__glow" aria-hidden="true" />
      <div className="wrap hero__grid">
        <div className="hero__copy">
          <p className="eyebrow eyebrow--live">
            <span className="dot-live" /> Voice AI for restaurants
          </p>
          <h1 className="display">
            Every call answered.
            <br />
            <em>Every order bigger.</em>
          </h1>
          <p className="lead">
            {BRAND} picks up every call in your customer's language. It takes the full order, suggests
            the dessert, and sends the ticket to your kitchen printer, so your staff can stay on the
            food in front of them.
          </p>
          <div className="hero__ctas">
            <a className="btn btn--primary btn--lg" href="#demo">
              Book a demo <Icon name="arrow" size={18} />
            </a>
            <a className="btn btn--ghost btn--lg" href="#voice-ai">
              <Icon name="play" size={16} /> Hear a sample call
            </a>
          </div>
          <ul className="hero__proof">
            <li>
              <strong>24/7</strong>
              <span>Answers during the dinner rush and after close</span>
            </li>
            <li>
              <strong>{LANGUAGES.length}+</strong>
              <span>Languages, including Spanish, Chinese and Punjabi</span>
            </li>
            <li>
              <strong>0</strong>
              <span>Callers on hold. Every line is picked up</span>
            </li>
          </ul>
        </div>
        <LiveCall />
      </div>

      <div className="marquee" aria-hidden="true">
        <div className="marquee__track">
          {[...LANGUAGES, ...LANGUAGES].map((l, i) => (
            <span key={i}>
              {l.hello} <i>·</i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
